import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { LogIn, Key, Smartphone, Shield } from "lucide-react";
import * as tests from "./testDefinitions";

export const LoginSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Login & Permissions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Smartphone}
          iconColor="text-blue-600"
          title="Super Easy Login"
          tests={tests.superEasyLoginTests}
          results={testResults.superEasyLogin}
        />
        
        <TestSubsection
          icon={Key}
          iconColor="text-amber-600"
          title="Promo Code Permissions"
          tests={tests.promoCodePermissionsTests}
          results={testResults.promoCodePermissions}
        />
      </CardContent>
    </Card>
  );
};
